import { Box, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import RegisterDetails from './Components/RegisterDetails';
import SpeakersCard from './Components/SpeakerCard';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router-dom';
import { getSpeakersList } from '../../../../../../../actions/meeting_actions';

const PreviewLeft = (props) =>
{
	const { type, id } = useParams();
	const { data } = props;
	const introVideo = data?.meetingDetails?.webinarIntroVideo?.key ? `${process.env.REACT_APP_S3_CLOUDFRONT}/${data?.meetingDetails?.webinarIntroVideo?.key}` : 'https://www.youtube.com/embed/CPITNY7apXU';
	const [ speaker, setSpeaker ] = useState([]);
	const fetchSpeakerRecords = async () =>
	{
		const queryParams = {
			sessionId : window.atob(id ?? ''), // webinar id
			limit     : 10,
			skip      : 0
		};

		try
		{
			const res = await getSpeakersList(queryParams);

			if (res?.status)
			{
				setSpeaker(res?.data);
			}
			else
			{
				setSpeaker([]);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.error('Error fetching webinar data:', err);
		}
	};

	useEffect(() =>
	{
		fetchSpeakerRecords();
	}, []);

	return (
		<Stack direction={'column'} height={'var(--percent100)'}>
			{type === 'waiting' && <Box pt='var(--pixel8)' pb='var(--pixel16)' width={'var(--percent100)'} sx={{ aspectRatio: '16/9' }}>
				<ReactPlayer className='playerCntr'style={{ borderRadius: 'var(--pixel8)', overflow: 'hidden' }} width={'var(--percent100)'} height={'var(--percent100)'} url={introVideo ?? 'https://www.youtube.com/embed/CPITNY7apXU'} controls />
			</Box>}
			<RegisterDetails data={data}/>
			{speaker &&
			<SpeakersCard data={data} speakerData={speaker}/>}
		</Stack>
	);
};

export default PreviewLeft;
